(function(){
if(window.__inbikeBundleTipStarted)return;
window.__inbikeBundleTipStarted=true;
var wait=0,busy=false;
var topCopy=JSON.parse(document.querySelector('[data-ibk-bundle-tip]').getAttribute('data-ibk-config-0'));
var bottomCopy=JSON.parse(document.querySelector('[data-ibk-bundle-tip]').getAttribute('data-ibk-config-1'));
var kitTitle=JSON.parse(document.querySelector('[data-ibk-bundle-tip]').getAttribute('data-ibk-config-2'));
var kitCopy=JSON.parse(document.querySelector('[data-ibk-bundle-tip]').getAttribute('data-ibk-config-3'));
function details(item){
var s=((item.product_title||item.title||'')+' '+(item.handle||'')).toLowerCase();
if(/worry.free|shipping protection|gift card|insurance/.test(s))return null;
var type=/(bib tights|bib trousers|bib shorts|cycling tights|cycling shorts|cycling pants|cycling trousers)/.test(s)?'bottom':/(cycling jersey|fleece jersey|long sleeve jersey|short sleeve jersey)/.test(s)?'top':null;
if(!type)return null;
var gender=/women|womens|woman|ladies/.test(s)?'women':/men|mens|male/.test(s)?'men':null;
var season=/fleece|thermal|winter|bib tights|bib trousers/.test(s)?'winter':'summer';
return {type:type,gender:gender,season:season};
}
function render(cart){
var el=document.querySelector('[data-ibk-bundle-tip]');if(!el)return;
var items=(cart.items||[]).map(details).filter(Boolean);
if(!items.length){el.hidden=true;return}
var hasTop=items.some(function(x){return x.type==='top'}),hasBottom=items.some(function(x){return x.type==='bottom'});
var both=hasTop&&hasBottom,hasAccessory=(cart.items||[]).some(function(z){return /cycling gloves|cycling socks|thermal fleece long.finger|half.fingered cycling gloves/i.test(z.product_title||z.title||'')}),first=items[0],title=el.querySelector('[data-ibk-bundle-title]'),desc=el.querySelector('[data-ibk-bundle-description]');
var accessory=el.querySelector('[data-ibk-accessories]');if(accessory)accessory.hidden=true;
var groups=el.querySelectorAll('[data-ibk-group]'),wrapper=el.querySelector('[data-ibk-matches]'),link=el.querySelector('.ibk-bundle-tip__link');
groups.forEach(function(g){g.hidden=true});
if(both){
if(hasAccessory){title.textContent='Your kit is complete!';desc.textContent='13% off eligible 3-piece kits is applied at checkout.';}else{title.textContent=kitTitle;desc.textContent=kitCopy+' Add an eligible accessory to save up to 13% on a 3-piece kit at checkout.';var winter=items.some(function(x){return x.season==='winter'});if(accessory){var choices=accessory.querySelectorAll('[data-ibk-accessory-season]');choices.forEach(function(c){c.hidden=c.getAttribute('data-ibk-accessory-season')!==(winter?'winter':'summer')});accessory.hidden=!accessory.querySelector('[data-ibk-accessory-season]:not([hidden])');}}
if(wrapper)wrapper.hidden=true;if(link)link.hidden=true;
}else{
title.textContent='Complete your kit & save 12%';
desc.textContent=first.type==='bottom'?bottomCopy:topCopy;
var target=(first.gender||'')+'-'+first.season+'-'+(first.type==='bottom'?'top':'bottom');
var found=el.querySelector('[data-ibk-group="'+target+'"]');
var available=found&&found.querySelector('.ibk-match');
if(wrapper)wrapper.hidden=!available;
if(found&&available)found.hidden=false;
if(link){link.hidden=!!available;link.textContent='Explore all eligible kits →'}
}
el.hidden=false;
}
async function update(){
if(busy)return;busy=true;
try{var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
var response=await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store'});
if(!response.ok)throw Error('cart fetch');render(await response.json());
}catch(e){var el=document.querySelector('[data-ibk-bundle-tip]');if(el)el.hidden=true}
finally{busy=false}
}
function refresh(){clearTimeout(wait);wait=setTimeout(update,350)}
function start(){
refresh();var drawer=document.querySelector('cart-drawer-component');
if(drawer)new MutationObserver(function(changes){for(var i=0;i<changes.length;i++){var node=changes[i].target;if(node instanceof Element&&node.closest('[data-inbike-rewards], [data-ibk-bundle-tip]'))continue;if(node instanceof Element&&node.closest('cart-drawer-component')){refresh();break}}}).observe(drawer,{subtree:true,childList:true});
document.addEventListener('cart:update',refresh);document.addEventListener('cart:updated',refresh);document.addEventListener('shopify:section:load',refresh);
document.addEventListener('click',function(e){if(e.target.closest('[data-testid="cart-drawer-trigger"],.cart-items__quantity-controls,.cart-items__remove'))setTimeout(refresh,500)},true);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
